import axios from "axios";
import { Message } from "element-ui";
import store from "@/store";
import { removeToken } from "./cookie";

// 开发环境走 /api 代理，生产环境同域部署
const baseURL = process.env.VUE_APP_ENV === "production" ? "" : "/api";

const http = axios.create({
  baseURL,
  timeout: 60 * 1000,
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
  },
});

http.interceptors.request.use((config) => {
  const token = store.state.token;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

http.interceptors.response.use(
  (response) => {
    const res = response.data;
    // 后端约定：code == 0 成功；2001 未登录/登录过期
    if (res.code === 0) {
      return res;
    }
    if (res.code === 2001) {
      Message.error(res.msg || "请先登录");
      store.commit("clearAuth");
    } else {
      Message.error(res.msg || "请求发生错误");
    }
    return Promise.reject(res);
  },
  (error) => {
    const status = error && error.response ? error.response.status : 0;
    const tips = {
      401: "您已下线，请重新登录",
      403: "拒绝访问",
      404: "服务器暂无响应，请您稍后重试",
      408: "请求超时",
      500: "服务器端出错",
      502: "网络错误",
      503: "服务不可用",
      504: "网络超时",
    };
    error.message =
      tips[status] || (status ? `未知错误${status}` : "连接到服务器失败");
    if (status === 401) {
      store.commit("clearAuth");
    }
    Message.error(error.message);
    return Promise.reject(error);
  }
);

export default http;
